var render = function render(){var _vm=this,_c=_vm._self._c;return _c('adv-input-spinner',{attrs:{"min":_vm.productCodeData.productStock > 0 ? 1 : 0,"max":_vm.productCodeData.productStock,"quantity":_vm.localQuantity,"button-css":_vm.buttonCss,"unavailable":!this.productCodeId || _vm.productCodeData.productStock <= 0},on:{"quantity-changed":_vm.quantityChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }